import React from 'react';
export function Footer() {
  return <footer className="bg-brand-slateDeep px-4 py-12 text-center text-sm text-white/70" data-id="element-70" data-mp="32wd2qgad7ltj">
      <div className="mx-auto max-w-4xl" data-id="element-71" data-mp="3ggtymjf7hl5r">
        <div className="mb-3 font-serif text-xl font-bold text-white" data-id="element-72" data-mp="32nulup6t651w">PILATES REFORMER PRÊT™️</div>
        <p className="mx-auto max-w-md text-xs leading-relaxed text-white/60" data-id="element-73" data-mp="36pfu1x8edv5r">
          La méthode complète et prête à imprimer pour les professeurs de Pilates Reformer, du niveau Fondamentaux au
          niveau Avancé II.
        </p>
        <nav aria-label="Informations légales" className="mb-8 mt-8 flex flex-wrap items-center justify-center gap-6" data-id="element-74" data-mp="37o5kstgztcb">
          <a href="#conditions" className="transition-colors duration-150 ease-out hover:text-white" data-id="element-75" data-mp="3ldu4ouc22nwv">
            Conditions Générales
          </a>
          <a href="#confidentialite" className="transition-colors duration-150 ease-out hover:text-white" data-id="element-76" data-mp="29zgli2s8ywn6">
            Confidentialité
          </a>
          <a href="#contact" className="transition-colors duration-150 ease-out hover:text-white" data-id="element-77" data-mp="2ezuvhqdesgnu">
            Contact
          </a>
        </nav>
        <p data-id="element-78" data-mp="3gapcfgy9ogex">PILATES REFORMER PRÊT™️ · Tous droits réservés</p>
      </div>
    </footer>;
}